module.exports = __webpack_public_path__ + "img/homeautoinstaller.2448be93.png";